<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Email Newsletter', route: '/backoffice/newsletter' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">EMAIL NEWSLETTER</h1>
</section>

<section class="pb-16 mb-8 px-container">        
    <div class="row w-full flex lg:justify-end">
        <button class="p-3 lg:w-1/4 w-full btn-outln mb-8 text-center" type="button" routerLink="/backoffice/newsletter/add">                
            <i class="bi bi-plus"></i>
            Aggiungi email newsletter
        </button>
    </div>
            
    <p-table #dt [exportFilename]="'newsletters'"  [columns]="[{field: 'email', header: 'Email'}]" [loading]="loading" [value]="newsletters" responsiveLayout="stack" [breakpoint]="'960px'" styleClass="p-datatable-striped" [paginator]="true" [showCurrentPageReport]="true" [rowHover]="true" [globalFilterFields]="['email']" currentPageReportTemplate="{first} di {last} su {totalRecords} email newsletter" [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">            
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-8">
                <span class="block lg:w-1/4 w-full p-input-icon-left">
                    <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                    <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca..." class="w-full indent-6" />
                </span>
                <span class="lg:w-2/4 w-full lg:block hidden">
                </span>
                <span class="lg:w-1/4 w-full">
                    <button type="button" class="text-center btn-outln-backoffice p-2 py-[0.75rem] w-full font-medium"  (click)="dt.exportCSV()">Esporta</button>                                        
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="email" class="w-3/4">Email <span class="inline-flex"><p-sortIcon field="email" /></span></th>
                <th class="w-1/4 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-newsletter>
            <tr>
                <td><span class="p-column-title">Email</span>{{newsletter.email}}</td>
                <td class="md:justify-center justify-between flex"><span class="p-column-title">Azioni</span>

                    <div class="flex flex-row items-center justify-center">                                                            
                        <i class="bi bi-pencil lg:text-3xl text-2xl hover:text-accent cursor-pointer" [routerLink]="'/backoffice/newsletter/' + newsletter.id"></i>                        
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteNewsletter>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDeleteNewsletter()">Elimina</button>
                                        <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium"  (click)="onAnnullaDeleteNewsletter()">Annulla</button>                                        
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>

                        <i class="bi bi-trash lg:text-3xl text-2xl hover:text-accent cursor-pointer" (click)="onOpenDeleteNewsletter($event, newsletter)" ></i>
                    </div>
                    
                </td>                    
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">Nessuna email della newsletter trovata.</td>
            </tr>
        </ng-template>
    </p-table>
</section>